import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const quoteContext = createContext({});

const QuoteContextProvider = ({ children }) => {
  const [t, i18n] = useTranslation();
  const [error, setError] = useState(false);
  const [errorBeforePayment, setErrorBeforePayment] = useState(false);
  const [fromZipCode, setFromZipCode] = useState("");
  const [toCity, setToCity] = useState("");
  const [state, setState] = useState("");
  const [language, setLanguage] = useState("en");


  const [stateOption, setStateOption] = useState(null);
  const [colCities, setColCities] = useState({ cities: [] });
  const [loading, setLoading] = useState(false);
  const [colCitiesOptions, setColCitiesOptions] = useState([]);
  const [fromAndToCompleted, setFromAndToCompleted] = useState(false);
  const [cityOptionSelected, setCityOptionSelected] = useState();
  const [weight, setWeight] = useState();
  const [value, setValue] = useState();
  const [weightType, setWeightType] = useState();
  const [dimensionsType, setDimensionsType] = useState();
  const [dimensions, setDimensions] = useState({
    long: "",
    height: "",
    broad: "",
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [isFristStepComplete, setIsFristStepComplete] = useState(false);
  const [currentSubStep, setCurrentSubStep] = useState(1);
  const [createShipmentResponse, setCreateShipmentResponse] = useState({});
  const [selectedProvider, setSelectedProvider] = useState({
    label: "",
    id: 0,
  });

  const [citiesUsa, setCitiesUsa] = useState({});
  const [addressFrom, setAdressFrom] = useState(null);
  const [addressUsa, setAddressUsa] = useState([]);

  const [addressTo, setAddressTo] = useState(null);
  const [addressCol, setAddressCol] = useState([]);

  
  const handleCancel = () => {
    setDimensions({ long: "", height: "", broad: "" });
    setFromZipCode("");
    setToCity("");
    setState("");
    setStateOption(null);
    setColCities({ cities: [] });
    setFromAndToCompleted(false);
    setCityOptionSelected(null);
    setWeight();
    setValue();
    setWeightType();
    setDimensionsType();
    setCurrentStep(1);
    setCurrentSubStep(1);
    setIsFristStepComplete(false);
    setError(false);
    hanndleCleanNewAdress();
    setLoading(false);
  };

  // Function to validate a zip code
  const isValidZipCode = (zip) => zip;

  // Function to validate stateOption
  const isValidStateOption = (option) =>
    option ?
    typeof option.id === "number" &&
    typeof option.state === "string" &&
    typeof option.label === "string": false;

  // Function to validate stateOption
  const isValidColCitySelected = (option) =>
    option ?
    typeof option.id === "number" &&
    typeof option.state === "string" &&
    typeof option.label === "string": false;

  // Function to validate dimensions
  const isValidDimensions = (dim) =>
    dim && dim.long > 0 && dim.height > 0 && dim.broad > 0;

  // Function to validate value
  const isValidValue = (val) => {
    const numberValue = parseFloat(val);
    return !isNaN(numberValue) && numberValue > 1;
  };

  // Function to validate weight
  const isValidWeight = (weight) => weight > 0;


  useEffect(() => {
    
    const fromAndToCompleted  = () => [
      isValidZipCode(fromZipCode),
      isValidStateOption(stateOption),
      isValidColCitySelected(cityOptionSelected),
    ].every(Boolean);

      setCreateShipmentResponse({
          city_to: cityOptionSelected?.city
      })
   
    // Check the validity of all objects
    const allObjectsValid = [
      fromAndToCompleted(),
      isValidDimensions(dimensions),
      isValidValue(value),
      isValidWeight(weight),
    ].every(Boolean);

    setFromAndToCompleted(fromAndToCompleted);
    // Set the state based on the validation result
    setIsFristStepComplete(allObjectsValid);
    setSelectedProvider({
      label: "",
      id: 0,
    });
   }, [
    fromZipCode,
    stateOption,
    dimensions,
    dimensionsType,
    weight,
    value,
    weightType,
    cityOptionSelected
   ]);

  const mapShipment = isFristStepComplete && {
    city_to:  cityOptionSelected.city&&cityOptionSelected.city,
    state_from: stateOption?.state,
    zip_code_from_usa: fromZipCode,
    length: `${dimensions.long}`,
    width: `${dimensions.broad}`,
    height: `${dimensions.height}`,
    weight: `${weight}`,
    box_merch_value: value,
    distance_unit: dimensionsType?.id === 1 ? "cm" : "in",
    mass_unit: weightType?.id === 1 ? "lb" : "kg",
  };

  const [dataShipmentUsa, setDataShipmentUsa] = useState({
    // state: "",         // USA!
    city: "", // COL! (numeros id) - USA! (letras nombre de la ciudad)
    // zip: "",             // USA!
    neighborhood: "", // COL!
    address: "", // USA! - COL!
    indications: "", // USA    - COL!
    names: "", // USA! - COL!
    phone: "", // USA! - COL!
  });

  const [cityNewAddress, setCityNewAddress] = useState();
  const [neighborhoodNewAdress, setNeighborhoodNewAdress] = useState();
  const [addressNewAdress, setAddressNewAdress] = useState();
  const [indicationsNewAdress, setIidicationsNewAddress] = useState();
  const [namesNewAdress, setNamesNewAdress] = useState();
  const [phoneNewAdress, setPhoneNewAdress] = useState();
  const [emailNewAdress, setEmailNewAdress] = useState();

  const mapNewAdressUsa = {
    state: state,
    city: cityNewAddress&&`${cityNewAddress.id}`,
    zip: fromZipCode,
    address: addressNewAdress,
    indications: indicationsNewAdress,
    names: namesNewAdress,
    phone: phoneNewAdress,
  };

  const mapNewAdressCol = {
    city: cityOptionSelected&&`${cityOptionSelected.id}`,
    address: addressNewAdress,
    indications: indicationsNewAdress,
    names: namesNewAdress,
    phone: phoneNewAdress,
    neighborhood: neighborhoodNewAdress,
    zip: '',
    state: cityOptionSelected&&cityOptionSelected.state,
    email: emailNewAdress
  };

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const isEmailValid = () => emailPattern && emailPattern.test((emailNewAdress || "").trim());
  const isPhoneValid = () => Boolean((phoneNewAdress || "").trim().length > 0);
  const isNameValid = () => namesNewAdress&&namesNewAdress.length <= 50;
  const isAddressValid = () => addressNewAdress&&addressNewAdress.length <= 100;
  const isNeighborhoodNewAdress = () => neighborhoodNewAdress&&neighborhoodNewAdress.length <= 100;
  const isIndicationsValid = () => indicationsNewAdress&&indicationsNewAdress.length <= 100

  const canCreateAddress  = (isColAdress) => {
    if (isColAdress) {
      return isPhoneValid() && isNameValid() && isAddressValid() && isNeighborhoodNewAdress() && isEmailValid();
    }
    return isPhoneValid() && isNameValid() && isAddressValid() && cityNewAddress;
  }

  const [isValidNewAddress, setIsValidNewAddress] = useState(false);
  const [isColNewAdress, setIsColAdress] = useState(false);

  useEffect(
    ()=> {
      setIsValidNewAddress(canCreateAddress(isColNewAdress));
    },
    [
      cityNewAddress,
      addressNewAdress,
      phoneNewAdress,
      namesNewAdress,
      neighborhoodNewAdress,
      emailNewAdress,
      indicationsNewAdress
    ]
  );
  const hanndleCleanNewAdress = () => {
    setCityNewAddress();
    setAddressNewAdress();
    setIidicationsNewAddress();
    setNamesNewAdress();
    setPhoneNewAdress();
    setNeighborhoodNewAdress();
    setEmailNewAdress();
  }


  const [shipmentCompletedData, setShipmentCompletedData] = useState(null);



  useEffect(()=> {
    const lenguaje = JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es';
    // setDimensionsType();
    i18n.changeLanguage(lenguaje);

  },[]);

  useEffect(()=> {
    // setDimensionsType();

  },[language]);

    useEffect(()=> {
        if(currentSubStep === 1 || currentSubStep === 2){
            setSelectedProvider({...selectedProvider, id: 0, label: ""})
        }

    },[currentSubStep]);

  const [errorNewAdress, setErrorNewAdress] = useState(false);
  
  const getLenguaje = ()=> {
     return JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es';
  }

  return (
    <quoteContext.Provider
      value={{
        isEmailValid,
        isPhoneValid,
        isNameValid,
        isAddressValid,
        isNeighborhoodNewAdress,
        isIndicationsValid,
        errorNewAdress, 
        setErrorNewAdress,
        isColNewAdress, 
        setIsColAdress,
        isValidNewAddress, 
        setIsValidNewAddress,
        canCreateAddress,
        emailNewAdress,
        setEmailNewAdress,
        getLenguaje,
        fromZipCode,
        setFromZipCode,
        toCity,
        setToCity,
        language,
        setLanguage,
        state,
        setState,
        stateOption,
        setStateOption,
        colCities,
        setColCities,
        colCitiesOptions,
        setColCitiesOptions,
        loading,
        setLoading,
        fromAndToCompleted,
        setFromAndToCompleted,
        cityOptionSelected,
        setCityOptionSelected,
        weight,
        setWeight,
        value,
        setValue,
        dimensions,
        setDimensions,
        weightType,
        setWeightType,
        dimensionsType,
        setDimensionsType,
        handleCancel,
        isFristStepComplete,
        currentStep,
        setCurrentStep,
        currentSubStep,
        setCurrentSubStep,
        mapShipment,
        error,
        setError,
        createShipmentResponse,
        setCreateShipmentResponse,
        selectedProvider,
        setSelectedProvider,
        citiesUsa,
        setCitiesUsa,
        addressFrom,
        setAdressFrom,
        addressUsa,
        setAddressUsa,
        dataShipmentUsa,
        setDataShipmentUsa,
        addressTo,
        setAddressTo,
        addressCol,
        setAddressCol,
        errorBeforePayment,
        setErrorBeforePayment,
        cityNewAddress,
        setCityNewAddress,
        neighborhoodNewAdress,
        setNeighborhoodNewAdress,
        addressNewAdress,
        setAddressNewAdress,
        indicationsNewAdress,
        setIidicationsNewAddress,
        namesNewAdress,
        setNamesNewAdress,
        phoneNewAdress,
        setPhoneNewAdress,
        mapNewAdressUsa,
        mapNewAdressCol,
        hanndleCleanNewAdress,
        shipmentCompletedData, 
        setShipmentCompletedData
      }}
    >
      {children}
    </quoteContext.Provider>
  );
};

export { quoteContext, QuoteContextProvider };
